import styled, { css } from 'styled-components';

type ContainerProps = {
  hasBorder: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;

  ${({ hasBorder }) =>
    hasBorder &&
    css`
      width: 100%;
    `}

  ${({ theme, hasBorder }) =>
    hasBorder &&
    css`
      border-bottom: 1px solid ${theme.colors.primary};
    `}
`;
